import { PillProps } from "@faire/retailer-visitor-shared/components/LoggedOutPills/Pill";
import { StackedPillsWithTitle } from "@faire/retailer-visitor-shared/components/LoggedOutPills/StackedPillsWithTitle";
import { discoverSearch } from "@faire/retailer-visitor-shared/lib/seoPaths";
import { useLoggedOutCategoryPageCatNavResponse } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import capitalize from "lodash/capitalize";
import lowerCase from "lodash/lowerCase";
import React from "react";
import { styled } from "styled-components";

export const LoggedOutCategoryPageMoreInC3Pills: React.FC = () => {
  const {
    data: { moreInC3CategoryName, moreInC3Terms },
  } = useLoggedOutCategoryPageCatNavResponse();
  if (!moreInC3CategoryName || !moreInC3Terms?.length) {
    return null;
  }

  const pills: PillProps[] = moreInC3Terms.map((term) => {
    return {
      pillContent: capitalize(term),
      linkTo: discoverSearch(lowerCase(term)),
    };
  });

  return (
    <StyleStackedPillsWithTitle
      pills={pills}
      title={moreInC3CategoryName}
      useCarouselOnMobile
    />
  );
};

const StyleStackedPillsWithTitle = styled(StackedPillsWithTitle)`
  ${responsiveMediaQueries.mobile} {
    padding: 0 ${getSpacing("2x")};
  }
  margin-bottom: ${getSpacing("8x")};
`;
